export class Savings{
	init() {
		var self = this;

		$('.savings-slider').jRange({
			from: 0,
			to: 1000,
			step: 10,
			scale: [0,100,200,300,400,500,600,700,800,900,1000],
			showLabels: true,
			width: ($(window).width() > 992) ? $('.savings-slider').closest('.container').width() * 0.8 : $('.savings-slider').closest('.container').width(),
			onstatechange: function() {
				self.savingsMath(this);
			},
		});
		$('#range').keyup(function() {
			var value = this.value,
				time = $('.savings-time').data('value'),
				newValue =  time * value;

				$('.savings-amount').html(newValue + ' <span class="unit">zł</span>').data('value', newValue);
		});
	}
	savingsMath(slider){
		var counter = 11/15,
			sliderValue = parseInt(slider.highLabel[0].innerText),
			bottlesBG = Math.floor(sliderValue * counter),
			hourRate = $('#range').val(),
			timeSavings = Math.floor((sliderValue - bottlesBG) * 0.25),
			moneySavings = Math.floor(timeSavings * hourRate);

		$('.bigger-bottles').html(bottlesBG).data('value', bottlesBG);
		$('.savings-amount').html(moneySavings + ' <span class="unit">zł</span>').data('value', moneySavings);
		$('.savings-time').html(timeSavings + ' <span class="unit">godz.</span>').data('value', timeSavings);

	}
}